import React from 'react';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import CheckBox from '@spark/ui-components/components/form/CheckBox';

export const getAnexosColumns = (
  onExcluir,
  selectedIds,
  onToggleSelect,
  onToggleSelectAll,
  allPageSelected,
  selectAllDisabled
) => {
  const stripPrefix = (value) => {
    const raw = String(value || '');
    return raw.replace(/^(coleta|devolucao|cte|ric)\s*-\s*/i, '').trim();
  };

  const parseNome = (row) => {
    const nomeOriginal = stripPrefix(row?.nomeOriginal || row?.NomeOriginal || '');
    const baseName = nomeOriginal.replace(/\.[^/.]+$/, '');
    const parts = baseName.split('_');
    const tipo = parts[0] || '';
    const tipoLower = String(tipo).toLowerCase();
    let nomeMotorista = '';
    let cpfMotorista = '';
    let numeroContainer = '';

    if (tipoLower === 'cte') {
      numeroContainer = parts[1] || '';
    } else {
      nomeMotorista = parts[1] || '';
      cpfMotorista = parts[2] || '';
      numeroContainer = parts.length > 3 ? parts.slice(3).join('_') : '';
    }
    return { tipo, nomeMotorista, cpfMotorista, numeroContainer };
  };

  const columns = [
    {
      id: 'nomeOriginal',
      header: 'Nome Original',
      accessorKey: 'nomeOriginal',
      size: 40,
      enableSorting: true,
      cell: ({ getValue }) => {
        const value = stripPrefix(getValue());
        return (
          <span title={String(value)}>
            <TruncatedText value={value} maxLength={90} />
          </span>
        );
      }
    },
    {
      id: 'tipo',
      header: 'Tipo',
      accessorKey: 'tipo',
      size: 45,
      enableSorting: true,
      cell: ({ row, getValue }) => {
        const value = getValue() || parseNome(row?.original).tipo;
        return <TruncatedText value={value} maxLength={24} />;
      }
    },
    {
      id: 'nomeMotorista',
      header: 'Nome Motorista',
      accessorKey: 'nomeMotorista',
      size: 70,
      enableSorting: true,
      cell: ({ row, getValue }) => {
        const value = getValue() || parseNome(row?.original).nomeMotorista;
        return <TruncatedText value={value} maxLength={22} />;
      }
    },
    {
      id: 'cpfMotorista',
      header: 'CPF Motorista',
      accessorKey: 'cpfMotorista',
      size: 60,
      enableSorting: true,
      cell: ({ row, getValue }) => {
        const value = getValue() || parseNome(row?.original).cpfMotorista;
        return <TruncatedText value={value} maxLength={22} />;
      }
    },
    {
      id: 'numeroContainer',
      header: 'Numero Container',
      accessorKey: 'numeroContainer',
      size: 70,
      enableSorting: true,
      cell: ({ row, getValue }) => {
        const value = getValue() || parseNome(row?.original).numeroContainer;
        return <TruncatedText value={value} maxLength={14} />;
      }
    },
    {
      id: 'dataColetaDepot',
      header: 'Data Coleta',
      accessorKey: 'dataColetaDepot',
      size: 40,
      enableSorting: true,
      cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={18} />
    }
  ];

  if (onToggleSelect || onExcluir) {
    const headerContent = onToggleSelect ? (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>

        {onToggleSelectAll && (
          <Tooltip dir="top" text={allPageSelected ? 'Remover selecao da pagina' : 'Selecionar pagina'}>
            <span className="d-inline-flex align-items-center">
              <CheckBox
                name="select-all-anexos"
                checked={!!allPageSelected}
                disabled={!!selectAllDisabled}
                label=""
                onChange={(event) => {
                  event.stopPropagation();
                  onToggleSelectAll();
                }}
                onClick={(event) => event.stopPropagation()}
              />
            </span>
          </Tooltip>
        )}
        <span>Ações</span>
      </div>
    ) : (
      'Acoes'
    );

    const actionsColumn = {
      id: 'acoes',
      header: () => headerContent,
      accessorKey: 'id',
      size: 50,
      minSize: 50,
      enableHiding: false,
      enablePinning: true,
      enableSorting: false,
      cell: ({ row }) => (
        <div style={{ display: 'inline-flex', gap: 8, alignItems: 'center', flexWrap: 'nowrap' }}>
          {onToggleSelect && (
            <Tooltip dir="top" text={selectedIds?.includes(row.original.id) ? 'Remover selecao' : 'Selecionar'}>
              <span className="d-inline-flex align-items-center">
                <CheckBox
                  name={`select-${row.original.id}`}
                  checked={selectedIds?.includes(row.original.id)}
                  label=""
                  onChange={(event) => {
                    event.stopPropagation();
                    onToggleSelect(row.original);
                  }}
                  onClick={(event) => event.stopPropagation()}
                />
              </span>
            </Tooltip>
          )}
          {row.original?.urlArquivo && (
            <Tooltip dir="top" text="Visualizar">
              <span className="d-inline-block">
                <ButtonWithLoading
                  variant="outline-primary"
                  size="sm"
                  loading={false}
                  style={{ minWidth: 'auto' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    window.open(row.original.urlArquivo, '_blank', 'noopener');
                  }}
                >
                  <Icon name="search" size={14} />
                </ButtonWithLoading>
              </span>
            </Tooltip>
          )}
          {onExcluir && (
            <Tooltip dir="top" text="Excluir">
              <span className="d-inline-block">
                <ButtonWithLoading
                  variant="outline-danger"
                  size="sm"
                  loading={false}
                  style={{ minWidth: 'auto' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    onExcluir(row.original);
                  }}
                >
                  <Icon name="delete" size={14} />
                </ButtonWithLoading>
              </span>
            </Tooltip>
          )}
        </div>
      )
    };

    columns.unshift(actionsColumn);
  }

  return columns;
};
